import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { SwitchingTabs } from '../edit/ProductionsEditPage';

/**
 * 制作管理画面（追加）のページコンポーネント
 * @returns
 */
function ProductionsAddPage() {
  // 言語情報
  const { t } = useTranslation();

  return (
    <div id="main">
      <Helmet>
        <title>{t('CMS-POC|制作管理')}</title>
      </Helmet>
      <SwitchingTabs
        productionId={null}
        productionDivisionId={1}
        basicInfo={{ language_id: 1 }}
        event={{}}
        preperationItem={{}}
        parentChildList={[]}
        refetch={undefined}
      />
    </div>
  );
}

export default ProductionsAddPage;
